import React from "react";
import { useTranslation } from "react-i18next";
import { MainLayout } from "../../components/MainLayout";
import Settings from "./components/Settings/Settings";
import ReasonModal from "./components/ReasonModal/ReasonModal";
import "./SystemSettings.styles.scss";

const SystemSettings = ({
  tab,
  groups,
  edits,
  onFieldChange,
  changedCount,
  onSaveClick,
  onDiscard,
  showReasonModal,
  reason,
  onReasonChange,
  onCloseReasonModal,
  onConfirmSave,
}) => {
  const { t } = useTranslation();

  return (
    <MainLayout tab={tab} withSidebar={true}>
      <div className="system_settings_section">
        <h2 className={"section_title"}>{t("system_settings.title")}</h2>
        <p className="section_hint">{t("system_settings.hint")}</p>

        {groups.length === 0 ? (
          <p className="settings_empty">{t("system_settings.empty")}</p>
        ) : (
          groups.map((group) => (
            <Settings
              key={group.id}
              title={group.title}
              settings={group.items}
              edits={edits}
              onFieldChange={onFieldChange}
            />
          ))
        )}

        <div className="settings_actions">
          <button disabled={changedCount === 0} onClick={onSaveClick}>
            {changedCount > 0
              ? `${t("system_settings.save")} (${changedCount})`
              : t("system_settings.save")}
          </button>
          <button
            className="discard-button"
            disabled={changedCount === 0}
            onClick={onDiscard}
          >
            {t("system_settings.discard")}
          </button>
        </div>

        <ReasonModal
          isOpen={showReasonModal}
          reason={reason}
          changedCount={changedCount}
          onReasonChange={onReasonChange}
          onClose={onCloseReasonModal}
          onConfirm={onConfirmSave}
        />
      </div>
    </MainLayout>
  );
};

export default React.memo(SystemSettings);
